export const CompanyInfo = {
    "id": 1,
    "name": "Grafikmakeriet",
    "description": "Insert info about company here!",
    "org": "48343-483",
    "owner": "Linnéa Mäker",
    "location": "Mora, Dalarna"
}